import React, {Component} from 'react'

class TutorRow extends Component {
    render() {
        return (
            <div className='tutor-row'>
                <div id="tutor-row-img">
                    <img src={this.props.img} style={{borderRadius: '50%'}} alt="TutorPic"/>
                </div>
                <div className="card tutor-desc">
                    <h1>{this.props.name}</h1>
                    <h4 style={{color: '#5c5c5c', marginTop: '-20px'}}><i>{this.props.subjects}</i></h4>
                    <p>
                        {this.props.bio}
                    </p>
                </div>
            </div>
        )
    }
}

export default TutorRow